import { render, staticRenderFns } from "./apply-anchor.vue?vue&type=template&id=f7dec36a&scoped=true"
import script from "./apply-anchor.vue?vue&type=script&lang=js"
export * from "./apply-anchor.vue?vue&type=script&lang=js"
import style0 from "./apply-anchor.vue?vue&type=style&index=0&id=f7dec36a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dec36a",
  null
  
)

export default component.exports